import {Col, Row} from "reactstrap";

import Copyright from "./components/copyright";
import LinkSections from "./components/linkSections";


import "./style.scss";
import Instagram from "./components/topSection/instagram";
import Information from "./components/topSection/information";

const Footer = () => {

    return (
        <>
            {/*<Information/>*/}
            <footer className="footer-container">
                <div className=''>
                    <div className="container-costumer">
                        <Row className="w-100 ">
                            <Col sm={12} md={12}>
                                <LinkSections/>
                            </Col>
                        </Row>
                    </div>

                    <Copyright/>
                </div>
            </footer>
        </>
    );
};

export default Footer;
